// Accordion web component, with smooth animation and keyboard support
(() => {
  window.smoothAccordionState = {
    list: [],
    update() {
      this.list.forEach(item => {
        if (item.fulfilled === 'true' && item.wasOpen === 'false' && item.wasVisible === 'true') {
          item.setAccordionOpen();
        }
        if (item.fulfilled === 'false' && item.wasFulfilled === 'true') {
          item.setAccordionClosed();
        }
      })
    }
  }
  const template = document.createElement('template');
  template.innerHTML = `
    <style>
    :host {
      display: block;
    }
    
    .accordion-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      position: relative;
      padding: 1.2rem;
      padding-right: 16px;
      background-color: var(--accordion-header-background);
      min-height: 50px;
      box-sizing: border-box;
    }
    .icon {
      display: block;
      position: relative;
    }
    .icon::after, .icon::before {
      content: '';
      display: block;
      width: 1.3rem;
      height: 0.1rem;
      position: absolute;
      right: 0px;
      top: 50%;
      transform: translateY(-50%);
      background-color: #707070;
      transition: transform 0.3s ease-in-out;
    }
    .icon::after {
      transform: translateY(-50%) rotate(90deg);
    }
     
    .accordion-header[aria-expanded="true"] .icon::after {
      transform: translateY(-50%) rotate(0deg);
    }
    .accordion-pannel {
      overflow: hidden;
      height: 0px;
      will-change: height;
    }
    </style>
    <div class="accordion">
      <div class="accordion-header" role="button" aria-expanded="false" tabindex="0">
        <slot name="header"></slot>
        <i class="icon"></i>
      </div>
      <div class="accordion-pannel">
        <slot name="pannel"></slot>
      </div>
    </div>
  `;

  class Accordion extends HTMLElement {

    constructor() {
      super();

      const { cartEmpty, visible, fulfilled, index } = this.dataset;
      this.index = index;
      this.cartEmpty = cartEmpty;
      this.fulfilled = fulfilled;

      this.wasVisible = window.sessionStorage.getItem(`visible-${index}`);
      this.wasFulfilled = window.sessionStorage.getItem(`fulfilled-${index}`);
      this.wasOpen = sessionStorage.getItem(`accordion_drawer_open-${this.index}`) || 'false';


      window.sessionStorage.setItem(`fulfilled-${index}`, fulfilled);
      window.sessionStorage.setItem(`visible-${index}`, visible);
      this.attachShadow({ mode: 'open' });
      this.shadowRoot.appendChild(template.content.cloneNode(true));

      this.accordion = this.shadowRoot.querySelector('.accordion');
      this.accordionHeader = this.shadowRoot.querySelector('.accordion-header');
      this.accordionPannel = this.shadowRoot.querySelector('.accordion-pannel');
      if (this.wasVisible === 'false') {
        this.classList.add('invisible', 'hidden');
      }
      this.init();

      setTimeout(() => {
        this.accordionPannel.style.transition = 'height 0.45s ease-in-out';
      }, 100);

      this.accordionHeader.addEventListener('click', this.toggleAccordion.bind(this));
      this.accordionHeader.addEventListener('keyup', this.toggleAccordion.bind(this));
      window.smoothAccordionState.list[index] = this;

      if (visible !== this.wasVisible) {
        if (visible === 'true') {
          this.setAccordionVissible();
        } else {
          this.setAccordionHidden();
        }
      }
    }
    init() {
      if (this.cartEmpty === 'true' ) {
        this.setAccordionClosed();
        return
      }
      if (this.wasOpen === 'true') {
        this.setAccordionOpen();
      }
    }
    setAccordionHidden() {
      this.classList.add('invisible');
      this.setAccordionClosed()
      setTimeout(() => {
        this.classList.add('hidden');
        window.sessionStorage.setItem(`visible-${this.index}`, 'false');
      }, 400);
    }
    setAccordionVissible() {
      this.classList.remove('hidden');
      setTimeout(() => {
        this.classList.remove('invisible');
        window.sessionStorage.setItem(`visible-${this.index}`, 'true');
        if (this.fulfilled === 'true') {
          this.setAccordionOpen();
        }
      }, 100);
    }
    setAccordionOpen() {
      sessionStorage.setItem(`accordion_drawer_open-${this.index}`, 'true');
      this.accordionHeader.setAttribute('aria-expanded', 'true');
      this.accordionPannel.style.height = `${this.accordionPannel.scrollHeight}px`
      this.classList.add('open');
      this.wasOpen = 'true';
    }
    setAccordionClosed() {
      sessionStorage.setItem(`accordion_drawer_open-${this.index}`, 'false');
      this.accordionHeader.setAttribute('aria-expanded', 'false');
      this.accordionPannel.style.height = '0px'
      this.classList.remove('open');
      this.wasOpen = 'true';
    }

    toggleAccordion(e) {
      const { locked: isLocked = false } = this.dataset;
      if (e.type === 'keyup' && e.code !== 'Enter' && e.code !== 'Space') return;
      if (isLocked === 'true') return;

      if (this.accordionHeader.getAttribute('aria-expanded') === 'true') {
        this.setAccordionClosed()
      } else {
        this.setAccordionOpen()
      }
    }
  }
  customElements.define('smooth-accordion', Accordion);
})();
